import React from 'react';
import { Box, Typography, Tooltip, useTheme } from '@mui/material';

export type NoteEditedIndicatorProps = {
    updatedAt: Date;
    updatedByFirstName?: string;
    updatedByLastName?: string;
    updatedBy?: string;
};

export const NoteEditedIndicator: React.FunctionComponent<NoteEditedIndicatorProps> = function ({
    updatedAt,
    updatedByFirstName,
    updatedByLastName,
    updatedBy,
}) {
    const theme = useTheme();

    // Si on a le prénom/nom, on les utilise
    // Sinon on utilise l'email s'il existe
    // Sinon "anonyme" en dernier recours
    const updatedByName =
        updatedByFirstName && updatedByLastName
            ? `${updatedByFirstName} ${updatedByLastName}`
            : updatedByFirstName || updatedBy || 'anonyme';

    const tooltipContent = `Modifiée par ${updatedByName} le ${updatedAt.toLocaleDateString(
        'fr-FR',
        {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        },
    )} à ${updatedAt.toLocaleTimeString('fr-FR', {
        hour: '2-digit',
        minute: '2-digit',
    })}`;

    const containerStyles = {
        position: 'absolute' as const,
        bottom: '8px',
        right: '12px',
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
    };

    const textStyles = {
        color: theme.palette.text.disabled,
        fontSize: '0.7rem',
        fontStyle: 'italic',
        userSelect: 'none',
        cursor: 'pointer',
        '&:hover': {
            color: theme.palette.text.primary,
        },
    };

    const Component = Box;
    const componentProps = { sx: containerStyles };

    return (
        <Component {...componentProps}>
            <Tooltip
                title={tooltipContent}
                placement="top"
            >
                <Typography
                    variant="caption"
                    sx={textStyles}
                >
                    Modifiée
                </Typography>
            </Tooltip>
        </Component>
    );
};
